import { createFileRoute, redirect } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'
import { fetchAreas, fetchAreasList } from '@/features/areas/api'
import { getDefaultUserMeTenant } from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/sites/create'
)({
  meta: () => [{ title: MENU.REGISTERING_SITE }],
  beforeLoad: ({ context: { auth } }) => {
    if (auth?.user?.type !== USER_TYPE.OWNER) {
      // DCユーザー以外の場合は地点一覧にリダイレクト
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}/settings/sites`
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    context: { auth }
  }) => {
    const [areaSelectList, disabledAreasResponse] = await Promise.all([
      fetchAreas({ tenantKey }, abortController.signal),
      // 無効なエリアのみ取得
      fetchAreasList(
        { tenantKey, query: { page: -1, enable: false } },
        abortController.signal
      )
    ])

    const disabledAreaIds = disabledAreasResponse.data.map((area) => area.id)

    return {
      authUser: auth.user,
      areaSelectList,
      disabledAreaIds
    }
  }
})
